<template>
  <v-dialog v-model="dialog" persistent max-width="30%">
    <v-card>
      <v-card-title class="pa-0">
        <v-toolbar class="toolbar-color">
          <span class="headline ml-2">
            {{
              labelBtn != "Salvar"
                ? "Editar Meta Pagamento"
                : "Cadastrar Meta Pagamento"
            }}
          </span>
        </v-toolbar>
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-row align="center">
            <v-col lg="12" md="412" sm="12" cols="12">
              <BaseSelect
                single-line
                label="Tipo Meta"
                item-text="tipo_meta"
                item-value="id_tipo_meta"
                service="campanhaService.tipoMeta"
                v-model="formTipoMetaPagamento.id_tipo_meta"
                :rules="[rules.required]"
                clearable
              >
              </BaseSelect>
            </v-col>

            <v-col lg="12" md="412" sm="12" cols="12">
              <BaseSelect
                single-line
                label="Tipo Pagamento"
                item-text="tipo_pagamento"
                item-value="id_tipo_pagamento"
                service="campanhaService.tipoPagamento"
                clearable
                v-model="formTipoMetaPagamento.id_tipo_pagamento"
                :rules="[rules.required]"
              >
              </BaseSelect>
            </v-col>

            <v-col lg="12" md="412" sm="12" cols="12">
              <v-text-field
                v-model="formTipoMetaPagamento.descricao"
                label="Descrição"
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text @click="close()">Fechar</v-btn>
        <v-btn
          color="blue darken-1"
          text
          @click="labelBtn != 'Salvar' ? put() : send()"
          >{{ labelBtn }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import rules from "@/mixins/inputRules";
import BaseSelect from "@/components/shared/BaseSelectService";
import campanha from "@/services/http/campanhaService";

export default {
  name: "ModalTipoMetaPagamento",
  mixins: [rules],
  components: {
    BaseSelect
  },

  props: {
    tipoMetaPagamento: {
      type: Object
    },
    dialog: {
      type: Boolean,
      default: false
    },
    labelBtn: {
      type: String
    }
  },

  data() {
    return {
      campanhaService: {},
      formTipoMetaPagamento: {}
    };
  },
  watch: {
    tipoMetaPagamento(value) {
      this.formTipoMetaPagamento = value;
    }
  },

  methods: {
    close() {
      this.$emit("close");
      this.$refs.form.reset();
    },
    async send() {
      const validateStatus = this.$refs.form.validate();
      if (validateStatus) {
        await campanha()
          .tipoMetaPagamento()
          .store(this.formTipoMetaPagamento, {
            notification: true,
            menssage: "Meta pagamento cadastrada com sucesso!"
          });
      }
      this.close();
    },

    async put() {
      const validateStatus = this.$refs.form.validate();
      if (validateStatus) {
        await campanha()
          .tipoMetaPagamento(this.formTipoMetaPagamento.id_tipo_meta_pagamento)
          .update(this.formTipoMetaPagamento, {
            notification: true,
            message: "meta pagamento editada com sucesso!"
          });
      }

      this.close();
    }
  }
};
</script>
